
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getCandidatestatus = async () => {
  return await get<ApiResponse<any[]>>("/candidatestatus").then((res)=>{
      return res
    })
};

 